{
    "component-card-search-list.empty-state.title.non-final": "<strong>将此存储库链接到软件组件</strong>",
    "component-card.add-chat-channel": "添加聊天通道",
    "component-card.chat-channels": "聊天通道",
    "component-card.expander.show-more-link": "显示另外 {formattedCount} 个"
}
